import React, { useMemo } from "react";
import DataTable from "../../_Components/DataTable";
import SplitNumber from "../../_Components/SplitNumber";
import { Link } from "react-router-dom";
function DataGrid({ data }) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره بلیط",
      minWidth: 80,
    },
    {
      accessor: "basketId",
      Header: "شماره سفارش",
      minWidth: 100,
      Cell: ({ row }) => {
        return (
          <Link target="_blank" to={`/viewOrderContents/${row.original.basketId}`}>
            {row.original.basketId}
          </Link>
        );
      },
    },
    {
      accessor: "basketUserFullName",
      Header: "نام ونام خانوادگی",
      minWidth: "150px",
    },
    {
      accessor: "agentName",
      Header: "نماینده فروش",
      minWidth: "150px",
    },
    {
      accessor: "cityName",
      Header: "شهر",
      minWidth: "100px",
      Cell: ({ row }) => {
        const regionNames = row.original.amusementServiceRegions?.map((rgn) => rgn.region.name).join("، ");
        return regionNames;
      },
    },
    {
      accessor: "basketItemAmusementServiceName",
      Header: "تفریح",
      minWidth: "180px",
    },
    {
      accessor: "basketItemAmusementServiceReserveItemGroupTitle",
      Header: "آیتم",
      minWidth: "250px",
      Cell: ({ row }) => (
        <div>
          {row.original.hallEventTitle ? row.original.hallEventTitle : row.original.basketItemAmusementServiceReserveItemTitle +
            " - " +
            row.original.basketItemAmusementServiceReserveItemGroupTitle}
        </div>
      ),
    },
    {
      accessor: "basketItemSeat",
      Header: "صندلی",
      minWidth: "150px",
      Cell: ({ row }) => (!!row.original.hallSeatId &&
        <div>
          {"جایگاه: " + row.original.hallBlockName}
          <br />
          {"ردیف: " + row.original.hallRowName}
          <br />
          {"صندلی: " + row.original.hallSeatName}
        </div>
      ),
    },
    {
      accessor: "originalPrice",
      Header: "نرخ مصوب",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div style={{ textDecoration: "line-through" }}>
          <SplitNumber number={row.original.originalPrice} />
        </div>
      ),
    },

    {
      accessor: "salePrice",
      Header: "نرخ فروش",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.salePrice} />
        </div>
      ),
      Footer: (info) => {
        // Only calculate total profit if rows change
        const total = React.useMemo(
          () => info.rows.reduce((sum, row) => row.original.salePrice + sum, 0),
          [info.rows],
        );
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },
    {
      accessor: "basketItemPromoCodeDiscountPrice",
      Header: " کد تخفیف",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.promoCodeDiscountPrice} />
        </div>
      ),
    },
    {
      accessor: "price",
      Header: "قیمت نهایی",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.price} />
        </div>
      ),
      Footer: (info) => {
        // Only calculate total profit if rows change
        const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.price + sum, 0), [info.rows]);
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },
    {
      accessor: "supplierName",
      Header: "تامین کننده آیتم",
      minWidth: "150px",
    },
    {
      accessor: "supplierSettlementPrice",
      Header: "نرخ تسویه با تامین کننده",
      minWidth: "150px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.supplierSettlementPrice} />
        </div>
      ),
    },
    {
      accessor: "transactionSupplierName",
      Header: "تامین کننده پرداخت شده",
      minWidth: "150px",
    },
    {
      accessor: "payToWarrantyAmount",
      Header: "پرداخت به تامین کننده",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) => (
        <div className="">
          <SplitNumber number={row.original.payToWarrantyAmount} />
        </div>
      ),
      Footer: (info) => {

        const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.payToWarrantyAmount + sum, 0), [info.rows]);
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },
    {
      accessor: "receiveOfWarrantyAmount",
      Header: "دریافت از تامین کننده ",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) => (
        <div className="">
          <SplitNumber number={row.original.receiveOfWarrantyAmount} />
        </div>
      ),
      Footer: (info) => {

        const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.receiveOfWarrantyAmount + sum, 0), [info.rows]);
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },
    {
      accessor: "agentCommisionPrice",
      Header: "کمیسیون نماینده",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div className="">
          <SplitNumber number={row.original.agentCommisionPrice} />
        </div>
      ),
      Footer: (info) => {
        // Only calculate total profit if rows change
        const total = React.useMemo(
          () => info.rows.reduce((sum, row) => row.original.agentCommisionPrice + sum, 0),
          [info.rows],
        );
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },

    {
      accessor: "strAgentCommissionSettlementStatus",
      Header: "وضعیت پرداخت کمیسیون نماینده",
      minWidth: "150px",
    },
    {
      accessor: "profit",
      Header: "سود ",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) =>
        row.original.profit >= 0 ? (
          <div className="">
            <SplitNumber number={row.original.profit} />
          </div>
        ) : (
          <div className="text-danger">
            <SplitNumber number={row.original.profit} />
          </div>
        ),
      Footer: (info) => {
        // Only calculate total profit if rows change
        const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.profit + sum, 0), [info.rows]);
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
    },
    {
      accessor: "currentStatus",
      Header: "وضعیت",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={` rounded-pill px-2 py-1 d-flex justify-content-center ${row.original.currentStatus === "رهاسازی" || row.original.currentStatus === "جدید"
            ? "bg-light-primary text-primary"
            : row.original.currentStatus === "در_حال_پیگیری"
              ? "bg-light-info text-info"
              : row.original.currentStatus === "انجام_شده"
                ? "bg-light-success text-success"
                : row.original.currentStatus === "انجام_نشده"
                  ? "bg-light-danger text-danger"
                  : ""
            }`}
        >
          {row.original.currentStatus}
        </div>
      ),
    },
    {
      accessor: "cancelStatus",
      Header: "وضعیت کنسلی",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={` rounded-pill px-2 py-1 d-flex justify-content-center ${row.original.cancelStatus === "درخواست_کنسلی"
            ? "bg-light-primary text-primary"
            : row.original.cancelStatus === "پیگیری_کنسلی"
              ? "bg-light-info text-info"
              : row.original.cancelStatus === "کنسل_شد"
                ? "bg-light-danger text-danger"
                : row.original.cancelStatus === "رد_درخواست_کنسلی"
                  ? "bg-light-warning text-warning"
                  : "bg-light text-secondary"
            }`}
        >
          {row.original.cancelStatus}
        </div>
      ),
    },
    {
      accessor: "fineAmount",
      Header: " جریمه کاربر",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) => (
        <div className="">
          <SplitNumber number={row.original.fineAmount} />
        </div>
      ),
    },
    {
      accessor: "supplierFineAmount",
      Header: " جریمه تفریحان",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) => (
        <div className="">
          <SplitNumber number={row.original.supplierFineAmount} />
        </div>
      ),
    },
    {
      accessor: "basketItemCheckInDate",
      Header: "تاریخ استفاده",
      minWidth: "100px",
    },
    {
      accessor: "createdPersianTime",
      Header: "تاریخ ایجاد",
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      accessor: "lastAccountingActionDateTimePersianTime",
      Header: "تاریخ آخرین عملیات حسابداری",
      minWidth: "120px",
      maxWidth: "120px",
    },
    {
      accessor: "payToWarrantyPersianTime",
      Header: "تاریخ پرداخت به تامین کننده",
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      accessor: "receiveWarrantyPersianTime",
      Header: "تاریخ دریافت از تامین کننده",
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      accessor: "canceledBasketPersianTime",
      Header: "تاریخ کنسلی بلیط",
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      accessor: "agentCommissionPersianTime",
      Header: "تاریخ پرداختی کمیسیون نماینده",
      minWidth: "110px",
      maxWidth: "110px",
    },
    // {
    //     Header: 'عملیات',
    //     accessor: '',
    //     minWidth: 150,
    //     align: "center",
    //     Cell: ({ row }) => (
    //         <div className="text-center">

    //             {/* ویرایش */}
    //             <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/createOrEditService/${row.original.id}`}>
    //                 <i className='far fa-edit text-small'></i>
    //             </Link>
    //         </div>
    //     )
    // }
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 50, 100, 500, 1000, 2000],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    show_footer: true,
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
